import http from "./constants/http";
import resources from "./constants/resources";

// 즐겨찾기 리스트
export const fetchFavorites = async (body) => {
  const res = await http(resources.FAVORITES).post(body);

  const resData = {
    code: res?.data?.Code,
    data: res?.data?.Data?.Rows,
    count: res?.data?.Data?.count,
  };
  return resData;
};

// 즐겨찾기 등록
export const addFavorites = async (body) => {
  const res = await http(resources.FAVORITES).post(body);

  const resData = {
    code: res?.data?.Code,
    data: res?.data?.Data,
    msg: res?.data?.Data.Msg,
  };
  return resData;
};

// 즐겨찾기 삭제
export const deleteFavorites = async (body) => {
  const res = await http(resources.FAVORITES).post(body);

  const resData = {
    code: res?.data?.Code,
    data: res?.data?.Data,
    msg: res?.data?.Data.Msg,
  };
  return resData;
};

// 즐겨찾기 공통
export const favoritesApi = async (body) => {
  const res = await http(resources.FAVORITES).post(body);
  if (res.status === 200) {
    return res.data;
  } else {
    return res;
  }
};
